import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { scheduleMachine } from './schedule.machine';
export const useScheduleRef = () => feature('schedule');
export const useSchedule = <R>(selector: (snapshot: SnapshotFrom<typeof scheduleMachine>) => R) =>
  useFeature('schedule', selector);
